import React from 'react';
import { Button, ButtonProps } from 'antd';

export type AsyncButtonProps = ButtonProps;

export const AsyncButton: React.FC<AsyncButtonProps> = ({
  onChange,
  ...props
}) => {
  const [loading, setLoading] = React.useState(false);

  return (
    <Button
      {...props}
      loading={loading}
      onChange={async (...args) => {
        if (!onChange) {
          return false;
        }

        setLoading(true);

        try {
          await onChange(...args);
        } finally {
          setLoading(false);
        }
      }}
    />
  );
};
